export default __webpack_public_path__ + "static/media/RedHatDisplay-Light.f6d251bc.ttf";